import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';

/**
 * Componente Raiz
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  /**
   * Titulo
   */
  public title = 'contacto-porvenir';
  /**
   * Flag para controlar si reCAPTCHA ya está cargado
   */
  private recaptchaLoaded = false;

  /**
   * A callback method that is invoked immediately after the default change detector has
   * checked the directive's data-bound properties for the first time,
   * and before any of the view or content children have been checked.
   * It is invoked only once when the directive is instantiated.
   */
  ngOnInit(): void {
    this.loadRecaptchaScript();
  }

  /**
   * Metodo que carga el script de Google ReCaptcha Enterprise
   * Solucionado para evitar errores de CORS
   */
  public async loadRecaptchaScript(): Promise<void> {
    // Verificar si ya está cargado
    if (this.recaptchaLoaded || (window as any)['grecaptcha']) {
      return;
    }

    // Verificar si el script ya existe
    const existingScript = document.querySelector('script[src*="recaptcha"]');
    if (existingScript) {
      this.recaptchaLoaded = true;
      return;
    }

    try {
      await this.createRecaptchaScript();
    } catch (error) {
    }
  }

  /**
   * Crea y carga el script de reCAPTCHA Enterprise
   */
  private createRecaptchaScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${environment.googleCaptcha}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.recaptchaLoaded = true;
        resolve();
      };

      script.onerror = (error) => {
        reject(error);
      };

      // Agregar al head para mejor compatibilidad
      document.head.appendChild(script);
    });
  }
}
